import cx from "classnames";
import React from "react";

import "./BreakdownAlert.scss";

export interface IBreakdownAlertProps {
  type: "error";
}

const BreakdownAlert: React.FC<
  React.PropsWithChildren<IBreakdownAlertProps>
> = (props) => (
  <div
    className={cx("c-breakdown-alert", {
      [`c-breakdown-alert--${props.type}`]: true,
    })}
  >
    {props.children}
  </div>
);

export default BreakdownAlert;
